var app = angular.module('leonardo');

var SubcategoryCacheRestService = function(CacheService, SubCategoryRestService) {

  var service = {};
  
  service.getSubCategories = function() {
    return CacheService.getOrFetch('subcategories', function() {
      return SubCategoryRestService.getAll({ summary: true });
    });
  };

  return service;
};

app.factory('SubcategoryCacheRestService', ['CacheService', 'SubCategoryRestService', SubcategoryCacheRestService]);
